import { render, staticRenderFns } from "./PriceManagementCategories.vue?vue&type=template&id=5cf26044&"
import script from "./PriceManagementCategories.vue?vue&type=script&lang=js&"
export * from "./PriceManagementCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports